import React from 'react'
import { Route } from 'react-router-dom'
import { RecordRoute } from '../../../../shared/page/record-route'
import { TradeShowList } from './content/tradeshow-list'
import { TradeshowRecycle } from './content/tradeshow-recycle'
import { TradeShowAdd } from './content/tradeshow-add'
import { TradeShowEdit } from './content/tradeshow-edit'
import { Delete } from '../../../../shared/page/page-delete'
import { Purge } from '../../../../shared/page/page-purge'
import { useApFormTradeshow } from '../../../../api-new/state/content'

export const LayoutTradeshow = () => {
  return (
    <React.Fragment>
      <Route path="/org/tradeshow/list" component={TradeShowList} />
      <Route path="/org/tradeshow/list/add" component={TradeShowAdd} />
      <RecordRoute path="/org/tradeshow/list/edit/:tradeshowID" component={TradeShowEdit} />
      <RecordRoute path="/org/tradeshow/list/edit/:deleteID/delete">
        <Delete useApiForm={useApFormTradeshow} titleParam="name" successPath="/org/tradeshow/list" />
      </RecordRoute>

      <Route path="/org/tradeshow/list/recycle" component={TradeshowRecycle} />
      <RecordRoute path="/org/tradeshow/list/recycle/purge/:purgeID">
        <Purge useApiForm={useApFormTradeshow} titleParam="name" successPath="/org/tradeshow/list/recycle" />
      </RecordRoute>
    </React.Fragment>
  )
}
